import { useMailComposer } from 'components/mail/MailComposerProvider';
import UseContext from 'hooks/useContext';
import { useCallback } from 'react';

// The slide-over of the forms of a record page (components/SlideOver/dataSlideOver).
export const RECORD_FORM_PANEL = 'record_form';

/**
 * Opens a form of a record page in the slide-over, as the admin's panels
 * read their data from `objID`: `openRecordForm(kind, data)` with `kind` one
 * of note, call, event, lost, groupContact, groupCompany, groupInfo, and `data` the
 * record it works on ({ companyId | groupId, recordName, contacts… }). An
 * e-mail opens the floating window of components/mail instead.
 */
const useRecordPanels = () => {
  const { setObjID, setSlideOverType, setSlideOverShow } = UseContext();
  const { openComposer } = useMailComposer();
  const openRecordForm = useCallback(
    (kind, data) => {
      if (kind === 'email') {
        openComposer(data);
        return;
      }
      setObjID({ kind, ...data });
      setSlideOverType(RECORD_FORM_PANEL);
      setSlideOverShow(true);
    },
    [openComposer, setObjID, setSlideOverType, setSlideOverShow],
  );
  return { openRecordForm };
};

export default useRecordPanels;
